import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Info from 'components/bookings/past/info';
import Image from 'components/bookings/past/image';
import Details from 'components/bookings/past/details';
import BookAgain from 'components/location/buttons/book-again';
import Address from 'components/location/address';
import ParkingTimes from 'components/bookings/parking-times';
import ExpandDetails from 'components/common/buttons/expand-details';
import OnDemandIcon from 'components/bookings/past/on-demand-icon';

import Brand from 'models/brand';
import BookingModel from 'models/booking';
import { Location } from 'models/locations';
import Review from 'models/review';

import VisibilitySensor from 'react-visibility-sensor';
import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  booking: PropTypes.instanceOf(BookingModel).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  disabled: PropTypes.bool,
  review: PropTypes.instanceOf(Review),
  openModal: PropTypes.func.isRequired,
  reviewBooking: PropTypes.func.isRequired,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
  analyticsPosition: PropTypes.number,
};

const defaultProps = {
  disabled: false,
  review: null,
  analyticsPosition: 0,
};

class Booking extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.onClickMobile = this.onClickMobile.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onBookAgainClick = this.onBookAgainClick.bind(this);

    this.state = {
      selected: false,
    };
  }

  onVisibilityChange(isVisible) {
    const { trackEvent, app, location, booking, analyticsPosition } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({
        app,
        LocationID: location.id,
        LocationAddress: location.address,
        StateTime: booking.startTime,
        Departure: booking.endTime,
        Total: booking.pricePaid,
        PurchasedDate: booking.purchasedAt,
      });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'BookAgain',
        position: analyticsPosition.toString(),
      });
    }
  }

  onBookAgainClick() {
    const { trackEvent, app, location, booking, analyticsPosition } = this.props;
    const pageProperties = pageProps({
      app,
      LocationID: location.id,
      LocationAddress: location.address,
      StateTime: booking.startTime,
      Departure: booking.endTime,
      Total: booking.pricePaid,
      PurchasedDate: booking.purchasedAt,
    });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'BookAgain',
      position: analyticsPosition.toString(),
    });
  }

  onClick() {
    if (!this.props.booking.onDemand) {
      this.setState({
        selected: !this.state.selected,
      });
    }
  }

  onClickMobile() {
    this.props.openModal(this.props.booking.id.toString());
  }

  render() {
    const { selected } = this.state;
    const {
      disabled,
      booking,
      location,
      brand,
      review,
      reviewBooking,
      app,
      trackEvent,
      analyticsPosition,
    } = this.props;

    const onClick = disabled ? null : this.onClick;
    const onClickMobile = disabled ? null : this.onClickMobile;

    const bookingWrapperClasses = cx({
      'visible-xs': true,
      'shadowed-xs': true,
      'row': true,
      'mock-table-row': true,
      'disabled': disabled,
    });

    const addressClasses = cx({
      'col-sm-3': true,
      'col-xs-7': !booking.onDemand,
      'col-xs-12': booking.onDemand,
      'col-gutter-left-xs-0': !booking.onDemand,
      'col-gutter-left-sm-15': true,
    });

    return (
      <div className="past-booking">
        <div className="hidden-xs">
          <Info
            booking={booking}
            location={location}
            selected={selected}
            disabled={disabled}
            onClick={onClick}
            brand={brand}
          />
          <Details
            booking={booking}
            location={location}
            brand={brand}
            review={review}
            reviewBooking={reviewBooking}
            app={app}
            trackEvent={trackEvent}
            analyticsPosition={analyticsPosition}
            selected={selected}
          />
        </div>
        <div className={bookingWrapperClasses}>
          <Image booking={booking} location={location} />
          <div className={addressClasses}>
            <div className="booking-row">
              <div className="visible-xs-inline-block vertical-align-top margin-right-5">
                <OnDemandIcon onDemand={booking.onDemand} className="text-size-28 display-inline-block" />
              </div>
              <div className="display-inline-block">
                <Address location={location} />
              </div>
            </div>
            <div className="booking-row">
              <ParkingTimes
                booking={booking}
                className="text-size-10 padding-top-10"
                labelClassName="text-size-12 text-weight-book"
                hideTextLabel
              />
            </div>
          </div>
        </div>
        <div className="visible-xs row">
          <div className="col-xs-6 padding-right-0-xs">
            <ExpandDetails
              onClick={onClickMobile}
              refunded={disabled}
            />
          </div>
          <div className="col-xs-6 padding-left-0-xs">
            <VisibilitySensor onChange={v => this.onVisibilityChange(v)} partialVisibility>
              <div onClick={() => this.onBookAgainClick(analyticsPosition)}>
                <BookAgain
                  location={location}
                  venueID={booking.venueId}
                  booking={booking}
                  brand={brand}
                />
              </div>
            </VisibilitySensor>
          </div>
        </div>
      </div>
    );
  }
}

Booking.propTypes = propTypes;
Booking.defaultProps = defaultProps;
export default Booking;
